(function() {
  var MIN_QTY = 10;

  // >>> ЗАМЕНИ НА СВОИ ID ВСЕХ ВАРИАНТОВ ЭТОГО ТОВАРА <<<
  var TARGET_VARIANTS = [52323040559433, 52323040592201, 52631057498441]; // пример

  // Перехватываем любые формы /cart/add (продукт, quick add, карточки и т.п.)
  document.addEventListener('submit', function(e) {
    var form = e.target;
    try {
      if (!form || !form.matches('form[action*="/cart/add"]')) return;
    } catch (err) { return; }

    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;

    var variantId = parseInt(idInput.value, 10);
    if (!TARGET_VARIANTS.includes(variantId)) return; // не наш товар

    // Ищем количество (если нет — считаем, что 1)
    var qtyInput = form.querySelector('input[name="quantity"]');
    var currentQty = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;

    if (isNaN(currentQty) || currentQty < MIN_QTY) {
      e.preventDefault();
      if (qtyInput) {
        qtyInput.setAttribute('min', MIN_QTY);
        qtyInput.value = MIN_QTY;
      }
      alert('Minimum order for this product — ' + MIN_QTY + ' pieces.');
    }
  }, true);
})();